export const Colab = (flujax) => ({
  async getSpecs ({ questionnaireSpecId, label, status }) {
    return await flujax.fetch.post('/questionnaire/spec/get', { questionnaireSpecId, label, status })
  },
  async getSpecDetails (questionnaireSpecId, version) {
    let route = `/questionnaire/spec/${questionnaireSpecId}/get`
    if (version) {
      route = route + `?version=${version}`
    }
    return await flujax.fetch.post(route)
  },
  async createDraft (questionnaireSpecDto) {
    if (!questionnaireSpecDto) {
      return
    }
    return await flujax.set.post('/questionnaire/spec/createDraft', questionnaireSpecDto)
  },
  async saveSpec (questionnaireSpecDto) {
    return await flujax.set.post('/questionnaire/spec/save', questionnaireSpecDto)
  },
  async generateQuestionnaireKey ({ user, accountPlanId, label, sendEmail, version, previewSpecData, colabVariationId, savedSegmentId }) {
    if (!user || !accountPlanId) {
      return
    }
    const params = [`user=${encodeURIComponent(user)}`, `accountPlanId=${accountPlanId}`, `sendEmail=${sendEmail || true}`]
    if (colabVariationId) {
      params.push(`colabVariationId=${colabVariationId}`)
    }
    if (label) {
      params.push(`questionnaireSpecLabel=${label}`)
    }
    if (version) {
      params.push(`questionnaireSpecVersion=${version}`)
    }
    if (savedSegmentId) {
      params.push(`savedSegmentId=${savedSegmentId}`)
    }

    return flujax.post(`/generated/key?${params.join('&')}`, previewSpecData || {})
  },
  async getBuilderData ({ accountPlanId }) {
    if (!accountPlanId) {
      return
    }
    return await flujax.fetch.post(`/questionnaire/builderData?accountPlanId=${accountPlanId}`)
  },
  async approveForm (submission) {
    return await flujax.post('/listData/colab/data/approve', submission)
  },
  async disapproveForm (submission) {
    return await flujax.post('/listData/colab/data/cancel', submission)
  },
  async getDashboards () {
    return await flujax.get('/colab/dashboards/get')
  },
  async getReports () {
    return await flujax.get('/colab/reports/get')
  },
  async getForms () {
    return await flujax.get('/colab/forms/get')
  },
  async getInvitations () {
    return await flujax.get('/colab/invitations/get')
  },

  async getBrandKits () {
    return await flujax.get('/colab/brandKit/list')
  },

  async getVariations () {
    return await flujax.get('/colab/variation/list')
  },
  async setVariation (payload) {
    return await flujax.set.post('/colab/variation/set', payload)
  },
  async setInvitationVariation (payload) {
    return await flujax.post('/colab/invitation/set', payload)
  },
  async setInvitationResend (payload) {
    return await flujax.post('/colab/invitation/resend', payload)
  },
  async setInvitationRevoke (payload) {
    return await flujax.post('/colab/invitation/revoke', payload)
  },
  async setBrandKit (payload) {
    return await flujax.set.post('/colab/brandKit/set', payload)
  }
})
